var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing__notification" },
    [
      _c("div", { staticClass: "notification__header" }, [
        _c("h1", [_vm._v("Teated")]),
        _vm._v(" "),
        _c("div", { staticClass: "notification__controls" }, [
          _c("button", { class: _vm.prevButtonClass, on: { click: _vm.prev } }),
          _vm._v(" "),
          _c("button", { class: _vm.nextButtonClass, on: { click: _vm.next } })
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.articles, function(item) {
        return _c(
          "div",
          {
            staticClass: "notification__list",
            on: { mouseover: _vm.turnOffTimeout, mouseleave: _vm.turnOnTimeout }
          },
          [
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.display,
                      expression: "item.display"
                    }
                  ],
                  staticClass: "notification__list-item"
                },
                [
                  _c("div", [
                    _c("div", [
                      _c("img", {
                        staticClass: "notification__img",
                        attrs: { src: item.iconLink }
                      })
                    ]),
                    _vm._v(" "),
                    _c("h2", [_vm._v(_vm._s(item.title))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "landing__training__form__submit" },
                    [
                      _c(
                        "a",
                        { staticClass: "link", attrs: { href: item.link } },
                        [_vm._v("VAATA LÄHEMALT")]
                      )
                    ]
                  )
                ]
              )
            ])
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "notification__list-item notification__list-item--hidden"
        },
        [
          _c("div", [
            _c("div", [
              _c("img", {
                staticClass: "notification__img",
                attrs: { src: _vm.longestMessage.iconLink }
              })
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.longestMessage.title))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing__training__form__submit" }, [
            _c(
              "a",
              { staticClass: "link", attrs: { href: _vm.longestMessage.link } },
              [_vm._v("VAATA LÄHEMALT")]
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a75501e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a75501e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/MessageSlider/MessageSlider.vue
// module id = 520
// module chunks = 1